import { useState } from "react";
import { IconCash, IconClipboardList, IconPackage, IconTruck } from "@tabler/icons-react";
import { Heading } from "../../../../components/common/typography";
import { StatCard } from "../../../../components/common/stat-card";
import { AdminDateRangePicker } from "../components/admin-date-range-picker";
import { PendingDocumentReviewsCard } from "../components/pending-document-reviews-card";
import { PendingProductApprovalsCard } from "../components/pending-product-approvals-card";
import { PendingDeliveryApprovalsCard } from "../components/pending-delivery-approvals-card";
import { PendingChangeRequestsCard } from "../components/pending-change-requests-card";
import { useAdminDashboardStats } from "../../hooks/useAdminDashboardStats";
import { useAdminStats } from "../../hooks/useAdminStats";
import { computePresetDates } from "../components/admin-date-range-picker";

const DEFAULT_PRESET = "This Quarter" as const;
const { start: DEFAULT_START, end: DEFAULT_END } = computePresetDates(DEFAULT_PRESET);

export function AdminDashboardPage() {
  const [startDate, setStartDate] = useState(DEFAULT_START);
  const [endDate, setEndDate] = useState(DEFAULT_END);
  const { pendingActions } = useAdminDashboardStats();
  const { data: stats } = useAdminStats(startDate, endDate);

  return (
    <div className="flex min-h-full w-full flex-col gap-6 bg-bgLight px-4 py-6 md:px-8 md:py-8">
      <Heading variant="h2" tone="dark">Dashboard</Heading>

      <AdminDateRangePicker
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={setStartDate}
        onEndDateChange={setEndDate}
        defaultPreset={DEFAULT_PRESET}
      />

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 max-md:grid-cols-1 max-md:gap-3">
        <StatCard iconTone="ghostMuted" icon={<IconTruck         size={24} />} label="Total Revenue"       value={stats ? `QAR ${stats.totalRevenue.toLocaleString()}` : "—"} />
        <StatCard iconTone="ghostMuted" icon={<IconPackage       size={24} />} label="Procurtal Profit"    value={stats?.procurtalMargin != null ? `QAR ${stats.procurtalMargin.toLocaleString()}` : "—"} />
        <StatCard iconTone="ghostMuted" icon={<IconClipboardList size={24} />} label="Pending Actions"     value={`${pendingActions} items`} />
        <StatCard iconTone="ghostMuted" icon={<IconCash          size={24} />} label="Payouts Outstanding" value={stats ? `QAR ${stats.payoutsOutstanding.toLocaleString()}` : "—"} />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <PendingDocumentReviewsCard />
        <PendingProductApprovalsCard />
        <PendingChangeRequestsCard />
        <PendingDeliveryApprovalsCard />
      </div>
    </div>
  );
}

export default AdminDashboardPage;
